import { createReducer } from "../../common/reduxUtil";
import { MODE_SEEK } from "../common/constants";
import {
  SET_FETCHING_SUBSCRIPTION_DATA,
  SET_GIG_LISTING_DATA,
  SET_GIG_LISTING_SUBSCRIPTION,
  SET_GIG_MODE,
  SET_SELECTED_SLOT,
  SET_SHOW_GIG_BOOKING_FLOW,
} from "./types";

const initialState = {
  mode: MODE_SEEK,
  listing: {},
  showBookingModal: false,
  startDateTimeISO: "",
  isFetchingGigDetails: true,
};

export default createReducer(initialState, {
  [SET_GIG_MODE]: (state, payload) => {
    return Object.assign({}, state, {
      mode: payload.mode,
    });
  },
  [SET_GIG_LISTING_DATA]: (state, payload) => {
    return Object.assign({}, state, {
      listing: payload.listing,
    });
  },

  [SET_GIG_LISTING_SUBSCRIPTION]: (state, payload) => {
    return Object.assign({}, state, {
      listing: { ...state.listing, subscription: payload.subscription },
    });
  },
  [SET_SHOW_GIG_BOOKING_FLOW]: (state, payload) => {
    return Object.assign({}, state, {
      showBookingModal: payload.value,
    });
  },
  [SET_SELECTED_SLOT]: (state, payload) => {
    return Object.assign({}, state, {
      startDateTimeISO: payload.value,
    });
  },
  [SET_FETCHING_SUBSCRIPTION_DATA]: (state, payload) => {
    return Object.assign({}, state, {
      isFetchingGigDetails: payload.value,
    });
  },
});
